import { IEstablishment } from './IEstablishment'

export const GET_ESTABLISHMENT_LOADING = 'GET_ESTABLISHMENT_LOADING'
export const GET_ESTABLISHMENT_SUCCESS = 'GET_ESTABLISHMENT_SUCCESS'
export const GET_ESTABLISHMENT_FAILURE = 'GET_ESTABLISHMENT_FAILURE'

interface IGetEstablishmentLoading {
  type: typeof GET_ESTABLISHMENT_LOADING
}

interface IGetEstablishmentSuccess {
  type: typeof GET_ESTABLISHMENT_SUCCESS
  payload: { establishment: IEstablishment }
}

interface IGetEstablishmentFailure {
  type: typeof GET_ESTABLISHMENT_FAILURE
  payload: { error: string }
}

export type TActionTypes =
  | IGetEstablishmentLoading
  | IGetEstablishmentSuccess
  | IGetEstablishmentFailure
